import React from "react";

const Footer = () => {
  return (
    <React.Fragment>
      <div className="footer">
        <div className="copyright">
          <p>
            Copyright © Designed &amp; Developed by{" "}
            <a href="#footer" target="_blank" rel="noreferrer">
              Nexuslink
            </a>{" "}
            2023
          </p>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Footer;
